// extracted by mini-css-extract-plugin
export var bulkPurchaseTable = "_a-0";